import React from 'react'
import Maintenance from './maintenance'

const IndexPage = () => (
  <Maintenance />
)

export default IndexPage
